var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`height:${_vm.height}px`)},[_c('h2',[_vm._v("\n    Credits\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }